import './FormControl-fa33984d.css';

var classes = {"ControlHorizontalLayout":"prc-FormControl-ControlHorizontalLayout-GkYZF","ControlVerticalLayout":"prc-FormControl-ControlVerticalLayout-wOp8f","ControlChoiceInputs":"prc-FormControl-ControlChoiceInputs-VxfAy","LabelContainer":"prc-FormControl-LabelContainer-lwQsw","LeadingVisual":"prc-FormControl-LeadingVisual-fEyC5"};

export { classes as default };
